// Max_value
export const maxValueByPurchasePrice = {
  bronze: { min: 0, max: 49999 },
  silver: { min: 50000, max: 119999 },
  gold: { min: 120000 },
};
